import GlobalItemTaxRateEditModal from './GlobalItemTaxRateEditModal';
export default GlobalItemTaxRateEditModal;
